export function createWindowSignalingEventDetail({
  message,
  providerId = null,
  deviceId = null,
  rawMessage = null,
  receivedAt = new Date().toISOString(),
} = {}) {
  if (!message || typeof message !== 'object') {
    return {
      command: null,
      payload: null,
      signalingProvider: providerId,
      deviceId,
      rawMessage,
      receivedAt,
    }
  }

  return {
    ...message,
    command: message?.command ?? null,
    payload: message?.payload ?? null,
    signalingProvider: providerId,
    deviceId,
    rawMessage,
    receivedAt,
  }
}

export function dispatchWindowSignalingEvent({
  dispatchEventKey,
  message,
  providerId = null,
  deviceId = null,
  rawMessage = null,
  target = typeof window !== 'undefined' ? window : null,
} = {}) {
  if (!target || !dispatchEventKey || !message) {
    return null
  }

  const detail = createWindowSignalingEventDetail({
    message,
    providerId,
    deviceId,
    rawMessage,
  })
  const event = new CustomEvent(dispatchEventKey, {
    detail,
  })

  target.dispatchEvent(event)

  return event
}

export function addWindowSignalingEventListener({
  dispatchEventKey,
  handler,
  target = typeof window !== 'undefined' ? window : null,
} = {}) {
  if (!target || !dispatchEventKey || typeof handler !== 'function') {
    return () => {}
  }

  target.addEventListener(dispatchEventKey, handler)

  return () => {
    target.removeEventListener(dispatchEventKey, handler)
  }
}
